import React from 'react'

import { MyWorkspacePill, routes } from '@sketch/modules-common'

// Constants
import { SKETCH_WEBSITE } from '@sketch/env-config'

// Compoments
import { useBreakpoint, Link, ExternalLink } from '@sketch/components'

// Local Components
import { PublicViewHiddenProfileBanner } from './PublicViewHiddenProfileBanner'
import LogoLink from '../LogoLink'
import ShareYourCreationsButton from '../ShareYourCreationsButton'

// Styles
import {
  CenterBannerWrapper,
  FullWidthBannerWrapper,
  Header,
  LeftSideLogoWrapper,
  RightSideButtonWrapper,
} from './PublicProfileHeader.styles'

// Types
import { InitialUserFragment } from '@sketch/gql-types'

export interface PublicProfileHeaderProps {
  workspaceId: string
  showHiddenProfileBanner: boolean
  user: Pick<InitialUserFragment, 'name' | 'avatar'> | undefined
}

export const PublicProfileHeader = (props: PublicProfileHeaderProps) => {
  const { user, workspaceId, showHiddenProfileBanner } = props

  const isLargeDesktop = useBreakpoint('lg')
  const isSmall = !useBreakpoint('sm')

  return (
    <>
      {!isLargeDesktop && user && showHiddenProfileBanner ? (
        <FullWidthBannerWrapper>
          <PublicViewHiddenProfileBanner
            workspaceId={workspaceId}
            rounded={false}
          />
        </FullWidthBannerWrapper>
      ) : null}
      <Header>
        <LeftSideLogoWrapper>
          <LogoLink user={user} />
        </LeftSideLogoWrapper>

        {/**
         * We are using Flex here (and in sibling components) because we want to center the banner within
         * the center of the screen and not in the center between two sibling components.
         * As it just happens, that two sibling components are of different width.
         * Also we want to keep the banner in a single line when it is rendered here
         * */}
        {isLargeDesktop && user && showHiddenProfileBanner ? (
          <CenterBannerWrapper>
            <PublicViewHiddenProfileBanner workspaceId={workspaceId} />
          </CenterBannerWrapper>
        ) : null}

        <RightSideButtonWrapper>
          {user ? (
            <Link to={{ pathname: routes.ENTRY.create({}) }}>
              <MyWorkspacePill user={user} />
            </Link>
          ) : (
            <ExternalLink href={SKETCH_WEBSITE}>
              <ShareYourCreationsButton dimmed={isSmall} />
            </ExternalLink>
          )}
        </RightSideButtonWrapper>
      </Header>
    </>
  )
}
